<template>
  <ModalBase @close-modal="close" show-modal narrow auto-h class="gk-modal-new-vat-report">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:title>
          <span v-translate>Generate New Report</span>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <!-- <b-form-group :label="$gettext('Year')" label-for="year-select">
        <b-form-select v-model="yearModal" :options="[...financialYears, ...{ text: $gettext('Select year'), value: null, disabled: true }]" id="year-select"></b-form-select>
      </b-form-group> -->
      <b-form-group :label="$gettext('Year')" label-for="year-select">
        <b-form-select v-model="yearModal" :options="financialYears" id="year-select"></b-form-select>
      </b-form-group>
      <b-form-group :label="$gettext('Period')" label-for="period-select">
        <b-form-select v-model="report_type" :options="REPORT_TYPES" id="period-select"></b-form-select>
      </b-form-group>
      <div v-if="report_type === 'quarterly'">
        <b-form-group :label="$gettext('Quarter')" label-for="quarter-select">
          <b-form-select v-model="quarterModal" :options="QUARTERS" id="quarter-select"></b-form-select>
        </b-form-group>
      </div>
      <div v-if="report_type === 'monthly'">
        <b-form-group :label="$gettext('Month')" label-for="month-select">
          <b-form-select v-model="monthModal" :options="MONTHS" id="month-select"></b-form-select>
        </b-form-group>
      </div>
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="handleSubmit()"
        :text="$gettext('Next')"
        icon="fa-solid fa-arrow-right"
        icon-right
      />
    </template>
  </ModalBase>
</template>
<script>
import { mapGetters } from "vuex";

import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "ReportsVATNewModal",
  components: {
      ModalBase,
      TitleBar,
      GekkoButton
  },
  props: {
    financialYears: {
      type: Array,
      default: () => {
        return []
      }
    },
    year: {
      required: false
    },
    quarter: {
      required: false
    },
    month: {
      required: false
    },
    consolidated: {
      required: false
    }
  },
  data () {
    return {
      yearModal: this.year,
      quarterModal: this.quarter,
      monthModal: this.month,
      report_type: this.getReportTypeSelected,
      QUARTERS: [
        { text: this.$gettext('Select quarter'), value: null, disabled: true },
        { text: 'Q1', value: 'Q1' },
        { text: 'Q2', value: 'Q2' },
        { text: 'Q3', value: 'Q3' },
        { text: 'Q4', value: 'Q4' }
      ],
      MONTHS: [
        { text: this.$gettext('Select month'), value: null, disabled: true },
        { text: this.$gettext('Jan'), value: 1 },
        { text: this.$gettext('Feb'), value: 2 },
        { text: this.$gettext('Mar'), value: 3 },
        { text: this.$gettext('Apr'), value: 4 },
        { text: this.$gettext('May'), value: 5 },
        { text: this.$gettext('Jun'), value: 6 },
        { text: this.$gettext('Jul'), value: 7 },
        { text: this.$gettext('Aug'), value: 8 },
        { text: this.$gettext('Sep'), value: 9 },
        { text: this.$gettext('Oct'), value: 10 },
        { text: this.$gettext('Nov'), value: 11 },
        { text: this.$gettext('Dec'), value: 12 }
      ],
      REPORT_TYPES: [
        { text: this.$gettext('Select period'), value: null, disabled: true },
        { text: this.$gettext('Monthly'), value: 'monthly' },
        { text: this.$gettext('Quarterly'), value: 'quarterly' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
    }),
    getReportTypeSelected () {
      if (this.month !== null) {
        return 'monthly'
      } else if (this.quarter !== null) {
        return 'quarterly'
      } else {
        return null
      }
    }
  },
  created () {
    this.yearModal = this.year
    this.quarterModal = this.quarter
    this.monthModal = this.month
    this.report_type = this.getReportTypeSelected
  },
  methods: {
    close () {
      document.body.classList.remove('modal-on')
      this.$emit('close', false)
    },
    calculateQuarter (month) {
      return 'Q' + Math.floor((month + 2) / 3)
    },
    handleOk () {
      this.handleSubmit()
    },
    handleSubmit () {
      let report_initial_values = {
        company: this.currentCompany.id,
        year: this.yearModal,
        month: this.monthModal,
        quarter: this.monthModal ? this.calculateQuarter(this.monthModal) : this.quarterModal,
        consolidated: this.consolidated,
        status: 'creating'
      }

      this.onSubmitBeforeEmit(report_initial_values);
      this.$emit('create', report_initial_values)
    },
    onSubmitBeforeEmit(report_initial_values){
    }
  }
}
</script>
<style lang="scss">
.gk-modal-new-vat-report {
  position: absolute;
  z-index: 9001;
  .gk-modal {
    max-width: 530px !important;
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>